import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-text-align-left-icon',
  templateUrl: './text-align-left.component.html'
})
export class TextAlignLeftComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
